import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const siteSliders= () => {
    const fullwidthSlider = () => {
        // Variables
        let fullwidthSliders = document.querySelectorAll('.fws-slider');
        // Check if USP sliders exist
        if (fullwidthSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        fullwidthSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 0,
                slidesPerView: 1,
        loop: true,
                speed: 700,
        pagination: {
            el: '.swiper-pagination',
                    clickable: true,
        },
    });
        });
    };

    const termpostSlider = () => {
        // Variables
        let termpostSliders = document.querySelectorAll('.termpost-wrapper');
        // Check if USP sliders exist
        if (termpostSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        termpostSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: 1.2,
        loop: true,
                speed: 700,
                navigation: {
                    nextEl: '.termpost-btn-next',
                    prevEl: '.termpost-btn-prev',
        },
                breakpoints: {
                    576: {
        slidesPerView: 2,
                        loop: true,
                    },
                    992: {
                        slidesPerView: 3,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 4,
                        loop: false,
                    },
                },
            });
        });
    };

    // Init Functions
    fullwidthSlider();
    termpostSlider();
};
document.addEventListener('DOMContentLoaded', () => {
    siteSliders();
});

